export default __webpack_public_path__ + "static/media/threejs.34faec93.svg";